var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vx-button',_vm._b({attrs:{"icon":"CopyIcon","size":"sm"},on:{"click":_vm.copy}},'vx-button',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }